import { FC, useCallback, useState } from "react"
import { subCasteDeleteApi } from "src/domain/api/subCaste/subCasteDeleteApi"
import { SubCaste } from "src/domain/entities/subCaste"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	subCaste: SubCaste
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const SubCasteDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	subCaste,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleSubCasteDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await subCasteDeleteApi({ id: subCaste.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [subCaste, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete SubCaste: ${subCaste.name.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleSubCasteDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
